export const serviceCategories = [
  {
    id: "securisation",
    label: "Sécurité / Dépannage",
    description: "Interventions rapides pour sécuriser vos accès, dépanner vos fermetures et protéger vos locaux.",
    services: [
      {
        slug: "rideaux-metalliques",
        title: "Rideaux métalliques",
        benefits: ["Sécurisation immédiate", "Motorisation fiable", "Dépannage 24h/24"],
        intro: "Pose, dépannage et motorisation de rideaux métalliques pour commerces et entrepôts.",
        image: "/assets/uploads/rideaux-metalliques.jpg",
        faqs: [
          { q: "Intervenez-vous en urgence ?", a: "Oui, nos équipes interviennent en urgence 24h/24 sur Maisons-Alfort et alentours." },
          { q: "Proposez-vous la motorisation ?", a: "Nous installons et remplaçons les motorisations adaptées à vos rideaux métalliques." },
        ],
      },
      {
        slug: "porte-blindee",
        title: "Porte blindée",
        benefits: ["Protection anti-effraction", "Pose certifiée", "Serrures haute sécurité"],
        intro: "Installation et dépannage de portes blindées pour particuliers et professionnels.",
        image: "/assets/uploads/porte-blindee.jpg",
        faqs: [
          { q: "Quelle porte choisir ?", a: "Nous vous conseillons selon le niveau de sécurité et la configuration de vos accès." },
          { q: "Assurez-vous la maintenance ?", a: "Oui, entretien et réglages pour garantir la performance de vos portes blindées." },
        ],
      },
      {
        slug: "vitrage-vitrines",
        title: "Vitrage & vitrines",
        benefits: ["Vitrage sécurisé", "Remplacement rapide", "Finitions propres"],
        intro: "Vitrage de sécurité, bris de glace et vitrines commerciales sur-mesure.",
        image: "/assets/uploads/vitrine.jpg",
        faqs: [
          { q: "Faites-vous le bris de glace ?", a: "Oui, nous sécurisons et remplaçons rapidement votre vitrage." },
          { q: "Vitrage anti-effraction ?", a: "Nous posons des vitrages feuilletés ou sécurit selon vos besoins." },
        ],
      },
      {
        slug: "enseignes",
        title: "Enseignes",
        benefits: ["Création sur-mesure", "Pose conforme", "Résistance extérieure"],
        intro: "Conception et installation d’enseignes pour commerces et entreprises.",
        image: "/assets/uploads/enseigne.jpg",
        faqs: [
          { q: "Prenez-vous en charge la pose ?", a: "Oui, de la fabrication à la pose sur site." },
          { q: "Mise aux normes ?", a: "Nous assurons le respect des normes locales et la conformité." },
        ],
      },
      {
        slug: "stores-bannes",
        title: "Stores bannes",
        benefits: ["Protection solaire", "Automatisation possible", "Pose rapide"],
        intro: "Installation, réparation et motorisation de stores bannes.",
        image:
          "https://images.unsplash.com/photo-1754835033746-620441bc4c7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxzdG9yZWZyb250JTIwYXduaW5nfGVufDB8fHx8MTc3MjU4MjcyN3ww&ixlib=rb-4.1.0&q=85",
        faqs: [
          { q: "Pouvez-vous motoriser un store ?", a: "Oui, nous proposons des motorisations adaptées." },
          { q: "Quel délai d’intervention ?", a: "Intervention rapide selon l’urgence et la disponibilité." },
        ],
      },
      {
        slug: "alarme-camera",
        title: "Caméra & systèmes d’alarme",
        benefits: ["Conseil sécurité", "Installation discrète", "Maintenance"],
        intro: "Solutions de vidéosurveillance et alarmes pour sécuriser vos locaux.",
        image:
          "https://images.unsplash.com/photo-1566060475410-1159300f046f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxzZWN1cml0eSUyMGNhbWVyYSUyMGNjdHZ8ZW58MHx8fHwxNzcyNTgyNzA0fDA&ixlib=rb-4.1.0&q=85",
        faqs: [
          { q: "Proposez-vous la maintenance ?", a: "Oui, avec des visites de contrôle régulières." },
          { q: "Installation rapide ?", a: "Nous planifions une intervention rapide selon vos contraintes." },
        ],
      },
    ],
  },
  {
    id: "travaux",
    label: "Travaux / Bâtiment",
    description: "Menuiserie aluminium, métallerie et automatismes pour vos projets de rénovation ou de construction.",
    services: [
      {
        slug: "menuiserie-alu",
        title: "Menuiserie aluminium",
        benefits: ["Sur-mesure", "Isolation renforcée", "Pose soignée"],
        intro: "Fabrication et pose de menuiseries aluminium pour particuliers et professionnels.",
        image: "/assets/uploads/baie-vitree.jpg",
        faqs: [
          { q: "Faites-vous le sur-mesure ?", a: "Oui, chaque menuiserie est adaptée à votre projet." },
          { q: "Pose complète ?", a: "Nous gérons la pose et les finitions." },
        ],
      },
      {
        slug: "metallerie",
        title: "Métallerie",
        benefits: ["Structures durables", "Soudure précise", "Finitions pro"],
        intro: "Création d’ouvrages métalliques : escaliers, garde-corps, structures sur mesure.",
        image:
          "https://images.unsplash.com/photo-1683470157197-ee1eb03d67cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxtZXRhbCUyMHdlbGRpbmclMjB3b3Jrc2hvcHxlbnwwfHx8fDE3NzI1ODI4NTZ8MA&ixlib=rb-4.1.0&q=85",
        faqs: [
          { q: "Intervenez-vous sur site ?", a: "Oui, prise de cotes et installation sur place." },
          { q: "Finitions personnalisées ?", a: "Plusieurs finitions sont disponibles selon vos besoins." },
        ],
      },
      {
        slug: "automatismes",
        title: "Automatismes",
        benefits: ["Confort d’usage", "Sécurité renforcée", "Maintenance"],
        intro: "Automatisation de portails, rideaux, portes et accès professionnels.",
        image: "/assets/uploads/volet-roulant.jpg",
        faqs: [
          { q: "Automatismes sur existant ?", a: "Oui, nous proposons des solutions adaptées." },
          { q: "Maintenance incluse ?", a: "Entretien et dépannage disponibles sur demande." },
        ],
      },
      {
        slug: "veranda-pergola",
        title: "Véranda / pergola",
        benefits: ["Design contemporain", "Confort thermique", "Structures aluminium"],
        intro: "Conception de vérandas et pergolas en aluminium pour vos espaces extérieurs.",
        image:
          "https://images.unsplash.com/photo-1703718326638-2853d4f87ff7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxwZXJnb2xhJTIwdGVycmFjZXxlbnwwfHx8fDE3NzI1ODI3NDh8MA&ixlib=rb-4.1.0&q=85",
        faqs: [
          { q: "Projet sur-mesure ?", a: "Oui, nous adaptons la structure à votre habitat." },
          { q: "Isolation ?", a: "Nous proposons des solutions isolantes performantes." },
        ],
      },
      {
        slug: "porte-automatique",
        title: "Porte automatique",
        benefits: ["Accès fluide", "Sécurité", "Maintenance"],
        intro: "Installation et dépannage de portes automatiques pour commerces et immeubles.",
        image:
          "https://images.unsplash.com/photo-1562322479-eadeb6c7a0c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxhdXRvbWF0aWMlMjBzbGlkaW5nJTIwZG9vciUyMGVudHJhbmNlfGVufDB8fHx8MTc3MjU4Mjg3NHww&ixlib=rb-4.1.0&q=85",
        faqs: [
          { q: "Intervenez-vous en urgence ?", a: "Oui, nous assurons les dépannages rapides." },
          { q: "Maintenance régulière ?", a: "Contrats de maintenance disponibles." },
        ],
      },
      {
        slug: "facade-alu-metal",
        title: "Façade aluminium & métal",
        benefits: ["Habillage durable", "Esthétique moderne", "Protection"],
        intro: "Habillage de façade, bardage métallique et solutions aluminium.",
        image:
          "https://images.unsplash.com/photo-1654105727849-1b9d39357f16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBnbGFzcyUyMGZhY2FkZSUyMGJ1aWxkaW5nfGVufDB8fHx8MTc3MjU4Mjc2N3ww&ixlib=rb-4.1.0&q=85",
        faqs: [
          { q: "Quels matériaux utilisez-vous ?", a: "Aluminium, acier et composites selon les projets." },
          { q: "Pose rapide ?", a: "Nous planifions un chantier optimisé pour limiter les délais." },
        ],
      },
      {
        slug: "cloture-portail",
        title: "Clôture / Portail",
        benefits: ["Sur-mesure", "Automatismes possibles", "Finition haut de gamme"],
        intro: "Fabrication et pose de clôtures et portails aluminium ou métal.",
        image:
          "https://images.unsplash.com/photo-1751482820198-094cc95d8476?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxtZXRhbCUyMGdhdGUlMjBmZW5jZXxlbnwwfHx8fDE3NzI1ODI4OTN8MA&ixlib=rb-4.1.0&q=85",
        faqs: [
          { q: "Portail motorisé ?", a: "Oui, nous intégrons les automatismes adaptés." },
          { q: "Délais ?", a: "Nous vous proposons un planning clair dès le devis." },
        ],
      },
      {
        slug: "portes-fenetres",
        title: "Portes / Fenêtres",
        benefits: ["Isolation renforcée", "Sécurité améliorée", "Pose rapide"],
        intro: "Remplacement et pose de portes et fenêtres aluminium.",
        image: "/assets/uploads/baie-vitree.jpg",
        faqs: [
          { q: "Travaillez-vous en rénovation ?", a: "Oui, pose en rénovation ou en neuf." },
          { q: "Quel niveau d’isolation ?", a: "Nous proposons différentes performances thermiques." },
        ],
      },
    ],
  },
];

export const servicesOptions = serviceCategories.reduce((acc, category) => {
  category.services.forEach((service) => {
    acc.push({
      ...service,
      category: category.label,
    });
  });
  return acc;
}, []);
